import React from 'react';

const ChangePasswordContext = React.createContext({
    confirmPasswordError: undefined,
    currentPassword: undefined,
    currentPasswordError: undefined,
    disableSubmitButton: undefined,
    newPassword: undefined,
    newPasswordConfirm: undefined,
    newPasswordError: undefined,
    onCurrentPasswordChange: undefined,
    onNewPasswordChange: undefined,
    onNewPasswordConfirmChange: undefined,
    onSubmitButtonClick: undefined,
    onBackButtonClick: undefined,
    onValidatorStateChange: undefined,
    showSuccessView: undefined,
});

ChangePasswordContext.displayName = 'ChangePasswordContext';

export default ChangePasswordContext;
